import React, { useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import { getSectorDetails } from "../../redux/homepage/saga";
import { SectorDetailDto } from "../../redux/homepage/type";
import { Helmet } from "react-helmet";
import { Loader } from "../../components";
import { useLocation, useParams } from "react-router-dom";
import { languageSelector } from "../../redux/languages";
import { isLoading } from "../../redux/loader";
import Slidewithcontrol from "../../components/Carousel";
import { appUrl, baseImageUrl } from "../../redux/base/types/url";

const SectorDetailPage = () => {
  const dispatch = useDispatch();
  const { sectorseo } = useParams();
  const [selectedSector, setSelectedSector] = useState<SectorDetailDto>();
  const location = useLocation();
  // const [google, setGoogle] = useState<string>();
  const loading = useSelector(isLoading);
  const language = useSelector(languageSelector);

  useLayoutEffect(() => {
    dispatch(
      getSectorDetails({
        payload: {
          onSuccess: (message, payload) => {
            setSelectedSector(payload);
          },
          onError: () => {},
        },
        id: sectorseo,
      })
    );
  }, [dispatch, sectorseo, language]);

  const title = selectedSector ? selectedSector.SeoTitle : "Rentificial";
  const desc = selectedSector ? selectedSector.SeoDescription : "Rentificial";
  return (
    <React.Fragment>
      <Helmet>
        <title>{title}</title>

        <meta name="title" content={title} />
        <meta name="description" content={desc} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={desc} />
        <meta
          name="twitter:image"
          content={baseImageUrl + selectedSector?.SeoImage}
        />
        <meta name="twitter:card" content={"large_summary_card"} />
        <meta name="twitter:site" content="@rentificial" />
        <meta name="twitter:creator" content="@rentificial" />
        <meta property="og:title" content={title} />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={desc} />
        <meta
          property="og:image"
          content={baseImageUrl + selectedSector?.SeoImage}
        />
        <meta property="og:url" content={appUrl + location.pathname} />
        <link  rel="canonical"  href={`https://www.rentificial.com/solutions/${sectorseo ? sectorseo : ""}`}/>

        <script type="application/ld+json">
          {`
                {
                  "@context": "https://schema.org",
                  "@type": "BreadcrumbList",
                  "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Homepage",
                    "item": "${appUrl}"
                  },{
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Spesifications",
                    "item": "${appUrl + "/solutions"}"
                  },{
                    "@type": "ListItem",
                    "position": 3,
                    "name": "${sectorseo}"
                  }]
                }`}
        </script>
        {/* {google && (
          <script type="application/ld+json">
            {`${JSON.stringify(google)}
                `}
          </script>
        )} */}
      </Helmet>
      <div className=" spesificationPage">
        {loading && <Loader />}
        <Container>
          <Row>
            <Col md={12}>
              {selectedSector && (
                <div className="spesificationImageContainer">
                  <Slidewithcontrol items={selectedSector.SectorSliders} />
                  <article className="mt-3 my-1">
                    <h1> {selectedSector.Name}</h1>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: selectedSector.Content,
                      }}
                    />
                  </article>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default SectorDetailPage;
